import {
  Sparkles,
  BarChart3,
  Rocket,
  Boxes,
  Clapperboard,
  PenLine,
  MonitorSmartphone,
  Camera,
} from "lucide-react";

export const WHATSAPP = "https://wa.me/918696938848";
export const CALENDLY = "https://calendly.com/contact-design4you/30min";
export const EMAIL = "contact@design4you.co.in";
export const INSTAGRAM = "https://www.instagram.com/designn_4_you?igsh=end2MmJyN3loMW1r";
export const LINKEDIN = "https://www.linkedin.com/in/s-deepankshi-2483693a6/";
export const FACEBOOK = "https://www.facebook.com/profile.php?id=61580865571957";
export const THREADS = "https://www.threads.com/@designn_4_you";
export const PHONES = ["+91 86969 38848", "+91 98758 79593"];

export const UPI_ID = "design4u.vk@okaxis";
export const UPI_NAME = "Deepankshi Saxena";
export const CONSULT_PRICE = 999;
export const UPI_LINK = `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(UPI_NAME)}&am=${CONSULT_PRICE}&cu=INR&tn=${encodeURIComponent("Design4you Premium Consultation")}`;

export const CONSULT_BENEFITS = [
  "In-depth 1:1 discussion about your brand, market & goals",
  "Personalised growth roadmap for your business",
  "Brand blueprint with relevant case studies",
  "Solutions deck — clear fixes, ideas & next steps",
  "Priority scheduling with the founder",
];

export const SERVICES = [
  {
    icon: Sparkles,
    title: "Premium Branding",
    desc: "Identity systems, logos & brand worlds engineered to command a premium and be remembered.",
  },
  {
    icon: BarChart3,
    title: "Digital Marketing",
    desc: "Full-funnel strategy, social & SEO that turns attention into a loyal, paying audience.",
  },
  {
    icon: Rocket,
    title: "Performance Marketing",
    desc: "Data-driven ad campaigns across Meta & Google, optimised relentlessly for ROI.",
  },
  {
    icon: Boxes,
    title: "2D / 3D Animation",
    desc: "Story-first animation and character work that makes brands move and feel alive.",
  },
  {
    icon: Clapperboard,
    title: "Motion Graphics",
    desc: "Kinetic type, explainers & reels crafted to stop the scroll in under a second.",
  },
  {
    icon: PenLine,
    title: "Content Writing",
    desc: "Sharp, on-brand copy & scripts that speak to both Indian and global audiences.",
  },
  {
    icon: MonitorSmartphone,
    title: "Website Design",
    desc: "Award-calibre websites — fast, responsive and conversion-obsessed by design.",
  },
  {
    icon: Camera,
    title: "3D CGI Ads & Ad Shoots",
    desc: "Cinematic commercial shoots blended with 3D CGI and AI for scroll-stopping ads.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Discovery Call",
    body: "We start by listening. A focused conversation to understand your goals, market and ambition — no jargon, no pressure.",
  },
  {
    no: "02",
    title: "Free 30-Min Consultation",
    body: "After the discovery call your first 30-minute strategy consultation is completely free. Real direction, before you spend a rupee.",
  },
  {
    no: "03",
    title: "Craft & Create",
    body: "Our specialists design, animate, shoot and write — obsessing over every frame, word and pixel until it feels premium.",
  },
  {
    no: "04",
    title: "Launch & Scale",
    body: "We ship, measure and optimise with performance marketing so your brand doesn't just look great — it grows.",
  },
];

export const PORTFOLIO = [
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Bishzu Biscuits — Signature Tin",
    img: "/portfolio/bishzu-1.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Bishzu — Rustic Story",
    img: "/portfolio/bishzu-2.jpg",
  },
  {
    tag: "Packaging & 3D CGI",
    cat: "Packaging",
    title: "Bishzu — Alpine Edition",
    img: "/portfolio/bishzu-3.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Bishzu — Heritage Edition",
    img: "/portfolio/bishzu-4.jpg",
  },
  {
    tag: "Packaging & 3D CGI",
    cat: "Packaging",
    title: "Bishzu — Ivory Edition",
    img: "/portfolio/bishzu-5.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Kes Kesar — Royal Campaign",
    img: "/portfolio/kesar-1.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Kes Kesar — Product Story",
    img: "/portfolio/kesar-2.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Kes Kesar — Ritual Series",
    img: "/portfolio/kesar-3.jpg",
  },
  {
    tag: "Packaging & 3D CGI",
    cat: "Packaging",
    title: "Kes Kesar — Regal Flat-lay",
    img: "/portfolio/kesar-4.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Kes Kesar — Nature Series",
    img: "/portfolio/kesar-5.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "KOIL — Queen of Spices",
    img: "/portfolio/koil-1.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "KOIL — Kashmiri Chilli",
    img: "/portfolio/koil-2.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "KOIL — Haldi Edition",
    img: "/portfolio/koil-3.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "KOIL — Dhaniya Edition",
    img: "/portfolio/koil-4.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "KOIL — Spice Flat-lay",
    img: "/portfolio/koil-5.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "KOIL — Garam Masala",
    img: "/portfolio/koil-6.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "KOIL — Pav Bhaji Masala",
    img: "/portfolio/koil-7.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "KOIL — Kitchen Story",
    img: "/portfolio/koil-8.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "KOIL — Chicken Masala",
    img: "/portfolio/koil-9.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "KOIL — Whole Cardamom",
    img: "/portfolio/koil-10.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Shoibeans — Chocolate Syrup",
    img: "/portfolio/shoibeans-1.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Shoibeans — Ivory Edition",
    img: "/portfolio/shoibeans-2.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Shoibeans — Royal Purple",
    img: "/portfolio/shoibeans-3.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Levinea — Fine Fragrances",
    img: "/portfolio/levinea-1.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Levinea — Scent Collection",
    img: "/portfolio/levinea-2.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Seve'nteaco — Tea & Coffee",
    img: "/portfolio/seventeaco-1.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Vaelis — Nourish & Renew Line",
    img: "/portfolio/vaelis-1.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Vaelis — Gift Ritual",
    img: "/portfolio/vaelis-2.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Vaelis — Brand Identity",
    img: "/portfolio/vaelis-3.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Vaelis — Product Blueprint",
    img: "/portfolio/vaelis-4.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Sevam — Ubtan Signature Tin",
    img: "/portfolio/sevam-1.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Sevam — Ayurvedic Collection",
    img: "/portfolio/sevam-2.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Sevam — Golden Rituals",
    img: "/portfolio/sevam-3.jpg",
  },
  {
    tag: "Packaging & 3D CGI",
    cat: "Packaging",
    title: "Sevam — Ayurvedic Flat-lay",
    img: "/portfolio/sevam-4.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Sevam — Nature Series",
    img: "/portfolio/sevam-5.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Sevam Tea — Green Tea Tin",
    img: "/portfolio/sevamtc-1.jpg",
  },
  {
    tag: "Packaging & 3D CGI",
    cat: "Packaging",
    title: "Sevam Tea — Signature Cone",
    img: "/portfolio/sevamtc-2.jpg",
  },
  {
    tag: "Packaging Design",
    cat: "Packaging",
    title: "Sevam Coffee — Premium Roast",
    img: "/portfolio/sevamtc-3.jpg",
  },
  {
    tag: "Brand Identity",
    cat: "Branding",
    title: "Sevam — Tea & Coffee Collection",
    img: "/portfolio/sevamtc-4.jpg",
  },
  {
    tag: "Campaign Creative",
    cat: "Campaign",
    title: "Sevam Coffee — Flavour Notes",
    img: "/portfolio/sevamtc-5.jpg",
  },
];

export const WORK_CATS = ["All", "Packaging", "Branding", "Campaign"];

export const BRANDS = [
  { name: "bishzu", sub: "Biscuits", cls: "font-head lowercase tracking-tight" },
  { name: "kés", sub: "Kesar", cls: "font-head lowercase tracking-tight" },
  { name: "KOIL", sub: "Queen of Spices", cls: "font-head uppercase tracking-[0.2em]" },
  { name: "LEVINEA", sub: "Fine Fragrances", cls: "font-head uppercase tracking-[0.15em]" },
  { name: "shoibeans", sub: "Chocolate", cls: "font-head lowercase tracking-tight" },
  { name: "seve'nteaco", sub: "Tea & Coffee", cls: "font-head lowercase tracking-tight" },
  { name: "VAELIS", sub: "Botanicals", cls: "font-head uppercase tracking-[0.2em]" },
  { name: "sevam", sub: "Ubtan · Tea & Coffee", cls: "font-head lowercase tracking-tight" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Design4you rebuilt our entire brand and the response was instant. It finally looks as premium as the product inside.",
    name: "Priya Nair",
    role: "Founder, Wellness D2C · Mumbai",
  },
  {
    quote:
      "Working across time zones was effortless. The 3D CGI ad they delivered outperformed every creative we've ever run.",
    name: "Daniel Rurik",
    role: "Marketing Head · Berlin",
  },
  {
    quote:
      "From strategy to the smallest motion detail — truly world-class. They earned our trust in the very first call.",
    name: "Aarav Mehta",
    role: "CEO, SaaS Startup · Bengaluru",
  },
  {
    quote:
      "A rare studio that gets both creativity and performance. Our ROAS doubled within the first quarter.",
    name: "Sophia Laurent",
    role: "Brand Director · Dubai",
  },
];

export const STATS = [
  { value: "10+", label: "Years crafting brands" },
  { value: "Global", label: "Clients across time zones" },
  { value: "9", label: "Creative disciplines" },
  { value: "1st", label: "30-min consult free" },
];
